import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-laptop",
  "use": "icon-laptop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-laptop\"><path d=\"M896 704 896 192c0-35.2-28.8-64-64-64L192 128c-35.2 0-64 28.8-64 64l0 512L0 704l0 192 1024 0 0-192L896 704zM640 832 384 832l0-64 256 0L640 832zM832 704 192 704 192 192.128c0.032-0.032 0.064-0.096 0.128-0.128l639.776 0c0.032 0.032 0.096 0.064 0.128 0.128L832 704z\" fill=\"#000000\" p-id=\"1317\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol